exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".outlets-list ons-list-item[data-v-aa19f51e]{background-color:#fff}.outlets-list-item-header[data-v-aa19f51e]{padding:0}.outlet-info-line[data-v-aa19f51e]{margin-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-aa19f51e","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/js/components/fragments/outlet_list_item.vue
// module id = ETT+
// module chunks = 0